import React from 'react';

export default function useMediaQuery(query) {
  const [matches, setMatches] = React.useState();

  React.useEffect(() => {
    const mql = window.matchMedia(query);
    setMatches(mql.matches);
    const handler = e => setMatches(e.matches);
    mql.addListener(handler);
    return () => mql.removeListener(handler);
  }, [query]);

  return matches;
}
